
class SocketService {
  static instance = null;
  connectionAttempts = 0;
  maxConnectionAttempts = 3;
  RECONNECTION_DELAY = 2000;
  connectionState = "disconnected";
  socket = null;
  messageCallback = null;

  constructor() {
    this.SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
  }

  setupBaseListeners() {
    this.socket.onopen = () => {
      console.log("Socket connected successfully");
      this.connectionAttempts = 0;
      this.connectionState = "connected";
    };

    this.socket.onerror = (error) => {
      console.error("Socket connection error:", error);
      this.handleReconnection();
    };

    this.socket.onclose = (event) => {
      console.log("Socket disconnected. Code:", event.code);
      this.connectionState = "disconnected";
      this.handleReconnection();
    };

    this.socket.onmessage = (event) => {
      console.log("Socket message received:", event.data);
      if (this.messageCallback) {
        this.messageCallback(event);
      }
    };
  }

  handleReconnection() {
    if (this.connectionAttempts < this.maxConnectionAttempts) {
      this.connectionAttempts++;
      console.log(
        `Attempting reconnection ${this.connectionAttempts}/${this.maxConnectionAttempts}`
      );
      setTimeout(() => {
        if (!this.socket.connected) {
          this.connect();
        }
      }, this.RECONNECTION_DELAY);
    } else {
      console.error("Max reconnection attempts reached");
    }
  }

  getConnectionState() {
    return this.connectionState;
  }

  static getInstance() {
    if (!SocketService.instance) {
      SocketService.instance = new SocketService();
    }
    return SocketService.instance;
  }

  connect() {
    if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
      this.socket = new WebSocket(this.SOCKET_URL);
      this.setupBaseListeners();
    }
  }

  disconnect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.close();
    }
  }

  isConnected() {
    return this.socket?.readyState === WebSocket.OPEN || false;
  }

  on(event, callback) {
    if (event === 'message') {
      this.messageCallback = callback;
    }
  }

  off(event, callback) {
    if (event === 'message') {
      this.messageCallback = null;
    }
  }

  getSocket() {
    return this.socket;
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    }
  }

  connectchat(clientId) {
    this.connect();
  }
}

const socketService = SocketService.getInstance();
export default socketService;
